import {API_CHAT_URL, API_URL} from "../../config";
import {authApi} from "../auth";
import axios from "axios";
let SOCKET_URL = API_CHAT_URL+'/api/v1'
// let token = await authApi.getToken()
// const config = {
//   ...token?.headers,
//   'Content-Type': 'application/json',
// };
class ChatApi {
  async getConfig() {
    let tokenData = await authApi.getToken();
    let accessToken = tokenData?.headers?.Authorization??null
    return {
        'Authorization': accessToken,
        'Content-Type': 'application/json',
    };
  }



  updateFCMChat= async (FCMToken) => {
    const headers = await this.getConfig(); // ดึง headers มาโดยตรง
    let response = await axios.post(SOCKET_URL + `/chat/update-fcm `,
        {
      "fcm_token": FCMToken,
      "sender_type": "admin"
    }
    , {headers})
    return {
      response,
    }
  };

  getListChat= async (data) => {
    const headers = await this.getConfig(); // ดึง headers มาโดยตรง

    let response = await axios.post(SOCKET_URL + `/admin/get-list `, data, {headers})
    return {
      response,
    }
  };
  removeChat= async (data) => {
    const headers = await this.getConfig(); // ดึง headers มาโดยตรง

    let response = await axios.post(SOCKET_URL + `/admin/del-list `, data,{headers})
    return {
      response,
    }
  };

  chatroom= async (data) => {
    const headers = await this.getConfig(); // ดึง headers มาโดยตรง

    let response = await axios.post(SOCKET_URL + `/chat/chatroom `, data,{headers});
    return {
      response,
    }
  };

  sendMessages = async (data) => {
    const headers = await this.getConfig(); // ดึง headers มาโดยตรง

    let response = await axios.post(SOCKET_URL + `/chat/message `, data,{headers});
    return {
      response,
    }
  };

  fetchData= async (data) => {
    const config = await this.getConfig(); // Get config inside the function

    let response = await axios.post(SOCKET_URL + `/chat/message `, data,config);
    return {
      response,
    }
  };

  requestMeet= async (data) => {
    const headers = await this.getConfig(); // ดึง headers มาโดยตรง

    let response = await axios.post(SOCKET_URL + `/meeting/request `, data,{headers});
    return {
      response,
    }
  };
  rejectMeet= async (data) => {
    const headers = await this.getConfig(); // ดึง headers มาโดยตรง

    let response = await axios.post(SOCKET_URL + `/meeting/reject`, data,{headers});
    return {
      response,
    }
  };
  confirmMeet= async (data) => {
    const headers = await this.getConfig(); // ดึง headers มาโดยตรง

    let response = await axios.post(SOCKET_URL + `/meeting/confirm`, data,{headers});
    return {
      response,
    }
  };


  updateRead= async (data) => {
    const headers = await this.getConfig(); // ดึง headers มาโดยตรง

    let response = await axios.post(SOCKET_URL + `/chat/update-read/`, data,{headers});
    return {
      response,
    }
  };




  addMessage() {

  }
}

export const chatApi = new ChatApi();
